import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { TodayView } from '@/features/today/components/today-view'

const todaySearchSchema = z.object({
  date: z.iso.date().optional(),
})

export const Route = createFileRoute('/_authed/today')({
  validateSearch: (search) => todaySearchSchema.parse(search),
  component: TodayView,
})
